import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import {
  sortNumeric,
  selectFormat,
  getMetricForColumn,
  Error,
} from "components/Utils/Utils.js";

class PocketWatchVideoTable extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { cells, title } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      // {
      //   dataField: "operator",
      //   text: "Operator",
      //   style: { width: "200px", minWidth: "200px", textAlign: "left" },
      //   headerAlign: "left",
      //   formatter: TableContentCell,
      //   csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
      //   sort: true,
      //   filter: textFilter({
      //     getFilter: (filter) => filter,
      //     placeholder: " ",
      //     className: "custom-table-filter-input",
      //     caseSensitive: false,
      //   }),
      // },
      {
        dataField: "operator",
        text: "Operator",
        style: { width: "100", minWidth: "100" },
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
        sort: true,
      },

      {
        dataField: "unique_impressions",
        text: "Unique Impressions",
        style: { width: "140px", minWidth: "140px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "total_impressions",
        text: "Total Impressions",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "requests",
        text: "Requests",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "attempts",
        text: "Attempts",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "video_views_complete",
        text: "Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "video_views_25_percent",
        text: "Views 25%",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "video_views_50_percent",
        text: "Views 50%",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "revenue",
        text: "Revenue",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "currency" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "$0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const pagination = paginationFactory({
      sizePerPage: 10,
      hideSizePerPage: true,
    });

    const defaultSorted = [
      {
        dataField: "video_views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            pagination={pagination}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;
    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default PocketWatchVideoTable;
